@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';
@import '../../../constants/screen-width-breakpoints.module.less';
@import (reference) '../../../constants/spacing.module.less';
@import (reference) '../settings-page.module.less';

.content {
  flex: 1;
  padding: @settings-page-content-padding;
}

.loading-indicator {
  height: 60%;
}

.content-body {
  max-width: 1400px;
  display: flex;
  gap: 40px;
  width: inherit;
  @media @tablet, @mobile, @ultramobile {
    flex-wrap: wrap-reverse;
    gap: @space-24;
  }
}

.content-main {
  flex: 1;
}

.content-section {
  width: 100%;
  min-width: 400px;
  margin: @space-16 @space-0 @space-24 @space-0;
  padding: @space-24;
  border-radius: 8px;
  border: 1px solid var(--grey-300);
  background: var(--white);
  @media @tablet, @mobile, @ultramobile {
    min-width: auto;
    margin-bottom: @space-24;
  }
}

.last-content-section {
  .content-section;
  margin-bottom: @space-16;
}

.setup-guide {
  // margin of section (content-section class) is 16px + line height of h2 title
  margin-top: calc(@space-16 + 2rem);
  @media @tablet, @mobile, @ultramobile {
    margin-top: @space-0;
  }
}
